export default __webpack_public_path__ + "images/icon--facebook.svg";